import {Col, List, Row} from "antd";
import {mapTitleDate} from "../common/mapTitleDate";
import {CheckOutlined} from "@ant-design/icons";
import React from "react";
import styled from "styled-components";
import {dataListWeek} from "../defaultValue/dataListWeek";

const StyledList = styled(List)`
  .ant-spin-container {
    height: ${(props) => props?.height + "px"};
    overflow-y: auto;
  }

  .ant-list-item {
    display: list-item !important;
    padding-right: 12px !important;
  }
`;
const RenderKeyWeek = ({type, handleSelect}) =>{

    return (
        <div className={"px-6"} >
            <StyledList
                header={null}
                footer={null}
                bordered={false}
                dataSource={dataListWeek()}
                renderItem={(item) => (
                    <List.Item>
                        <Row className={"items-center"}>
                            <Col span={23}>
                                <div className={"flex flex-col"} onClick={()=>handleSelect(item)}>
                                        <span style={{
                                            color: type === item.key ?  "#007FFF" : ""
                                        }}>
                                            {item.title}
                                        </span>
                                    <span>{
                                        mapTitleDate(item.key, item.startDate, item.endDate)
                                    }</span>
                                </div>
                            </Col>
                            <Col span={1}>
                                {
                                    type === item.key &&
                                    <CheckOutlined style={{ color: "#007FFF" }} />
                                }
                            </Col>
                        </Row>
                    </List.Item>
                )}
            />
        </div>
    )
}

export default RenderKeyWeek
